import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, LogOut, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useAdmin } from '../../context/AdminContext';
import { logoutUser } from '../../services/auth';
import './AdminNavbar.css';

const AdminNavbar = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { toggleSidebar } = useAdmin();

  const handleLogout = async () => {
    const result = await logoutUser();
    if (result.success) {
      navigate('/admin/login');
    }
  };

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-left">
        <button onClick={toggleSidebar} className="sidebar-toggle">
          <Menu size={24} />
        </button>
        <h1 className="admin-navbar-brand">IZZISHOW Admin</h1>
      </div>

      <div className="admin-navbar-right">
        <div className="admin-user-menu">
          <div className="admin-user-info">
            <User size={20} />
            <span className="admin-user-email">{user?.email}</span>
          </div>
          <button onClick={handleLogout} className="btn btn-ghost btn-sm logout-btn">
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;